const config = () => {
	let environmentVariables;

	// eslint-disable-next-line no-undef
	if ('production' === CORE_SITE_ENV.environment) {
		environmentVariables = {
			baseUrl: 'https://www.pushengage.com',
			backendApiUrl: 'https://dashboard-public-api.pushengage.com',
			googleClientId: '753591113224-3ci5nqq1arsscbh6o6ain6phg4t04948.apps.googleusercontent.com',
			appDashboardUrl: 'https://app.pushengage.com',
			stripeId: 'pk_live_wIT9Nd1ggsqeA8KuJSdtStZT',
			businessStarterPlanId: 'plan_OIqvCX8EZBlfDQ',
		};
	} else {
		environmentVariables = {
			baseUrl: 'https://staging.pushengage.com',
			backendApiUrl: 'https://staging-app.pushengage.com',
			googleClientId: '665262749631-543s48llp8hlgtrf35u8quqi2av81pvl.apps.googleusercontent.com',
			appDashboardUrl: 'https://staging-app-dashboard.pushengage.com',
			stripeId: 'pk_test_V5M3lt00yzkQqMNgcl90unbC',
			businessStarterPlanId: 'plan_OHj9YfOVbYikJN',
		};
	}

	return environmentVariables;
};

export default config;
